import { useState } from "react"

const InputQuantity = ({ max = 10, onChange }) => {
    const [current, setCurrent] = useState(1)

    const minus = () => {
        if (current > 1) {
            setCurrent(current - 1)
            onChange(current - 1)
        }
    }

    const plus = () => {
        if (current < max) {
            setCurrent(current + 1)
            onChange(current + 1)
        }
    }

    return (
        <div className="flex items-center w-fit border-white border-[1px]">
            <button className="flex justify-center items-center border-r-[1px] border-r-white w-5 h-5" onClick={minus}>
                <img src="/assets/icons/icon-arrow-left.svg" alt="minus" />
            </button>

            <div className="bg-transparent text-white text-xs px-2 !w-fit" >
                {current}
            </div>

            <button className="flex justify-center items-center border-l-[1px] border-l-white w-5 h-5" onClick={plus}>
                <img src="/assets/icons/icon-arrow-right.svg" alt="plus" />
            </button>
        </div>
    )
}

export default InputQuantity